import React, { useState } from 'react'
import styled from 'styled-components'
import ReactDropzone from 'react-dropzone'
import { FaFile } from 'react-icons/fa'

// Components
import { SectionLoader, S_SectionLoader } from '../_components/SectionLoader'
import { S_InvoiceManager } from '../_components/InvoiceManager/InvoiceManager'
import { DocumentList } from '../_components/DocumentsList'

// Constants

// Utils

// Services
import { uploadDocument } from '../_services/borrowingBaseCertificate.service'

// Styled Componenets
export const S_BBCDocumentsViewer = styled.div`
  margin: 30px 0;

  .upload-title {
    text-align: center;
    margin-bottom: 30px;
    font-weight: 300;
    font-size: 25px;
  }

  ${S_InvoiceManager} {
    margin-bottom: 25px;
  }

  .dropzone-wrapper {
    flex-grow: 1;
    width: calc(50% - 20px);
  }

  .dropzone,
  ${S_SectionLoader} {
    height: 200px;
    margin-bottom: 40px;
  }

  .dropzone {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    position: relative;
    cursor: pointer;
  }
  .content {
    position: relative;
    z-index: 2;
    text-align: center;
    svg {
      width: 60px;
      height: 60px;
      color: #999;
    }
  }
  .background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    border: 4px dashed #999;
  }
  .inner-background {
    height: 310px;
    width: 310px;
    border-radius: 50%;
    max-height: 100%;
    max-width: 100%;
    margin: 20px;
  }
`

const fileTypeMapping = {
  'Accounts Receivable': 'AR',
  Inventory: 'INV',
  Equipment: 'EQU',
  'Term Loan': 'TRM',
}

const titleMapping = {
  'Accounts Receivable': 'Accounts Receivable Documents',
  Inventory: 'Inventory Documents',
  Equipment: 'Equipment Documents',
  'Term Loan': 'Term Loan Documents',
  Summary: 'Supporting Documents',
}

export const BBCDocumentsViewer = ({
  bbcId,
  documents,
  fileType = 'Accounts Receivable',
  isLoadingDefault = false,
  addDocument = () => {},
}) => {
  const [isLoading, setIsLoading] = useState(isLoadingDefault)
  const [isUploading, setIsUploading] = useState(false)

  const fileTypeString = 'bbc-' + fileTypeMapping[fileType]
  const documentListTitle = titleMapping[fileType]

  const filteredDocuments = documents.filter((document) => {
    return document.document_type === fileTypeString
  })

  return (
    <S_BBCDocumentsViewer>
      {isLoading ? (
        <SectionLoader />
      ) : (
        <>
          {/* <InvoiceManager invoices={invoices} /> */}

          {/* List Documents */}
          <DocumentList documents={filteredDocuments} title={documentListTitle} />

          {isUploading ? (
            <SectionLoader />
          ) : (
            <>
              {/* Dropzone */}
              <ReactDropzone
                className={'dropzone'}
                disabled={false}
                multiple={true}
                onDrop={(acceptedFiles, rejectedFiles) => {
                  setIsUploading(true)
                  acceptedFiles.forEach
                  Promise.all(
                    acceptedFiles.map((acceptedFile) => {
                      return uploadDocument(acceptedFile, fileTypeString, bbcId).then((resp) => {
                        addDocument(resp)
                      })
                    })
                  ).then((values) => {
                    setIsUploading(false)
                  })
                }}
              >
                <div className="content">
                  <FaFile />
                  <div>Drop supporting documents here</div>
                </div>
                <div className="background">
                  <div className="inner-background"></div>
                </div>
              </ReactDropzone>
            </>
          )}
        </>
      )}
    </S_BBCDocumentsViewer>
  )
}
